import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import HomePage from './components/HomePage';
import BlogDetail from './components/BlogDetail';
import ReviewDetail from './components/ReviewDetail';
import AppDetail from './components/AppDetail';
import GetGame from './components/GetGame';
import GetApp from './components/GetApp';
import GameReviews from './components/GameReviews';
import AppReviews from './components/AppReviews';
import Blogs from './components/Blogs';
import AboutUs from './components/AboutUs';
import GameGrid from './components/GameGrid';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/review-game/:slug" element={<ReviewDetail />} />
          <Route path="/review-app/:slug" element={<AppDetail />} />
          <Route path="/get-game/:slug" element={<GetGameWrapper />} />
          <Route path="/get-app/:slug" element={<GetAppWrapper />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/game-reviews" element={<GameReviews />} />
          <Route path="/app-reviews" element={<AppReviews />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/premium" element={<GameGrid />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

function GetGameWrapper() {
  const { slug } = useParams();
  return <GetGame key={slug} />;
}

function GetAppWrapper() {
  const { slug } = useParams();
  return <GetApp key={slug} />;
}

export default App;
